<template>
<!-- 小区信息 -->
  <div class="eareaInfo bg-w" v-loading="loading">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>小区信息
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="content ub ub-pj">
      <div
        class="areaItem ub ub-pj ub-ac"
        v-for="(item,index) in dataList"
        :key="index"
      >
        <div class="ub-f1 areaItem-info">
          <div class="ft14 col-33 areaItem-title">
            <div class="eaAreaName" @click="enterEaArea(item.EaAreaCode)"><i class="el-icon-location icon-title"></i>{{item.EaAreaName}}</div>
            <div class="balance">
              <span class="balance-title">维修资金余额：</span>
              <span class="col-blue">￥{{item.ye || 0.00 | moneyFixed}}</span>            
            </div>
          </div>
          <div class="content-wrap">
            <div class="content-item">
              <div class="ft12 col-66 content-detail">
                <span class="item-title">物业服务企业</span>
                <span class="item-content">：{{item.RealtyMngOrgName  || "-"}}</span> 
              </div> 
              <div class="content-nav" v-if="!showMenu"><span class="click-nav" @click="linkTo('eaHouseReg','房屋补充',item.EaAreaCode)">房屋补充</span></div> 
              <div class="content-nav" v-else><span class="click-nav" @click="linkTo('tenderRecord', '招标备案',item.EaAreaCode)">招标备案</span></div>
            </div>    
            <div class="content-item">
              <div class="ft12 col-66 content-detail">
                <span class="item-title">项目经理</span>
                <span class="item-content" v-if="item.RealtyManage || item.RealtyManageCall ">：{{item.RealtyManage}} {{item.RealtyManageCall}}</span>
                <span class="item-content" v-else>：-</span>
              </div>
              <div class="content-nav" v-if="showMenu"><span class="click-nav" @click="linkTo('bidWinningRecord', '中标备案',item.EaAreaCode)">中标备案</span></div> 
            </div> 
            <div class="content-item ">
              <div class="ft12 col-66 content-detail">
                <span class="item-title">业委会</span>
                <span class="item-content">：{{item.OwnerTeamOrgName || "-"}}</span>
              </div>
              <div class="content-nav"><span class="click-nav"></span></div> 
            </div> 
            <div class="content-item">
              <div class="ft12 col-66 content-detail">
                <span class="item-title">业委会主任</span>
                <span class="item-content" v-if="item.MasterName || item.MasterTel">：{{item.MasterName}}   {{item.MasterTel}}</span>
                <span class="item-content" v-else>：-</span>
              </div>
              <div class="content-nav"><span class="click-nav"></span></div> 
            </div> 
          </div>
        </div>
        <div class>
          <!-- <div class="tx-c mar-b">
            <el-button type="primary" size="mini" @click="eaHouse(item.EaAreaCode)">房屋补充</el-button>
          </div> -->
          <!-- <div class="tx-c">
            <el-button type="primary" size="mini">批量交款</el-button>
          </div> -->
        </div>
      </div>
    </div>
    <div class="tx-c mar-t" v-if="dataList.length<1">
      <svg-icon icon-class="NoWork" class="iconStyle"></svg-icon>
      <br>暂无数据
    </div>
    <div class="ub ub-pc">
      <div class="more col-66 mar-r" @click="showMore">
        {{loadingOver?'加载完了':'加载更多'}}
        <i v-if="!loadingOver" class="el-icon-arrow-down"></i>
      </div>
      <div class="more col-66 mar-l" @click="closeMore" v-show="dataList.length>4">
        收起
        <i class="el-icon-arrow-up"></i>
      </div>
    </div>
  </div>
</template>

<script>
import {HomePageControllerSvr} from '@/service/HomePageControllerSvr/HomePageControllerSvr';
import nationalRegion from '@/utils/nationalRegion';
import { AuthenticationControllerSvr } from '@/service/AuthenticationControllerSvr';
import { mapState ,mapMutations} from 'vuex';
import { MyWorkControllerSvr } from '@/service/MyWorkControllerSvr';
export default {
  components: {},
  computed:{
    ...mapState(['token'])
  },
  props: {},
  data() {
    return {
      nationalRegion:nationalRegion,
      dataList: [],
      startIndex:0,
      maxSize:4,
      loading:false,
      loadingOver:false,
      showMenu: true,
    };
  },
  computed: {
    ...mapState(['token', 'userInfo'])
  },  
  created() {
    this.homePageControllerSvr = new HomePageControllerSvr();
    this.AuthenticationControllerSvr = new AuthenticationControllerSvr();  
    this.MyWorkControllerSvr = new MyWorkControllerSvr();
  },
  mounted() {
    //根据不同的用户显示菜单
    if (this.userInfo.UserParam.UserType === "物业服务企业用户") {
      this.showMenu = false
    }
    this.LoginId = this.$route.query.LoginId;
    this.getData();
  },
  methods: {
     ...mapMutations(['DEL_TABROUTER']),
    jumpMore(){
      this.$router.push('/queryPropertyArea');
    },
    //跳转至每个业务
    linkTo (router, workTemplateName, code) {
        this.MyWorkControllerSvr.startWork(this.$store.state.token, workTemplateName).then(res => {
          this.$router.push({
            path: router,
            query:{
                eaAreaCode: code,
                workId: res.WorkID,
                taskName: res.TaskName,
            }
          });

        });      
    },
    enterEaArea(code) {
      this.$router.push({
        path:'propertyAreaInfo',
        query:{
            EaAreaCode:code,
            t: Date.now()
        }
      });
    },
    showMore() {
      if(!this.loadingOver){
        this.startIndex+=this.maxSize;
        this.getData();
      }
    },
    closeMore(){
      this.loading=true;
      this.loadingOver=false;
      this.startIndex=0;
      this.maxSize=4;
      this.homePageControllerSvr.GetAreaInfo(this.token,this.startIndex,this.maxSize).then(res=>{
        this.dataList=res._Items;
        this.loading=false;
      }).catch(()=>{
        this.loading=false;
      });
    },
    getData(){
      this.loading=true;
      this.homePageControllerSvr.GetAreaInfo(this.token,this.startIndex,this.maxSize).then(res=>{
        this.dataList=this.dataList.concat(res._Items);
        if(res._Items.length<this.maxSize){
          this.loadingOver=true;
        }
        this.loading=false;
      }).catch(()=>{
        this.loading=false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>

.eareaInfo {
  width: 100%;
  padding-bottom: 10px;
  overflow: hidden;
  // height: 435px;
  .iconStyle {
    font-size: 100px;
    padding-bottom: 20px;
  }
  .content {
    width: 100%;
    padding: 0 10px;
    padding-top: 10px;
    height: 100%;
    flex-wrap: wrap;
    .balance {
      width: 50%;
      text-align: right;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;   
      .balance-title{
        font-weight: normal;

      }   
    }
    .eaAreaName{
      cursor: pointer;
      font-size: 18px;
      transition: all .3s;
      width: 50%;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;           
      &:hover{
        color: #4a94df;
      }
    }
    .areaItem {
      width: calc(50% - 5px);
      box-shadow: 0 0 10px #cad6ee;  
      margin-bottom: 10px;
      .areaItem-info  {
        overflow: hidden;
        .areaItem-title {
          height: 50px;
          line-height: 50px;
          padding: 0 20px;
          background: #f7f8fa;         
          font-size: 18px;     
          font-weight: Bold;
          display: flex;
          justify-content: space-between;
          .icon-title {
            font-size: 20px;
            padding-right: 10px;
            color: #0f77f1
          }
        }
      }
      .aline {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .col-red {
        color: #f75454;
      }
      .col-blue {
        color: #0f77f1
      }
    }
  }
  .ft12 {
    font-size: 14px;
    height: 35px;
    line-height: 35px;
  }
  .content-wrap {
    padding: 7px 20px;
    .content-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .content-detail {
        width: 80%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;   
        .tel {
          padding-left: 10px
        }
        .item-title {
          width: 25%;
          overflow: hidden;
          text-align: justify;
          text-align-last:justify;
          text-overflow:ellipsis;
          white-space: nowrap; 
        }   
        .item-content {
          width: 75%;
          display: inline-block;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;   

        }     
      }
      .content-nav {
        width: 20%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap; 
        text-align: right;           
      }
      .item-title {
        display: inline-block;
      }
      .content-nav {
        color: #0f77f1;
        text-decoration: underline;
        .click-nav {
          cursor: pointer;
        }
      }
    }
  }
  .more {
    cursor: pointer;
    transition: all .3s;
    &:hover{
      color: #4a94df;
    }
  }
}
</style>